import _ from 'lodash';

// Constants
import { isMobile, rightPaneWidth, menuWidth } from 'constants';

// Types
import * as types from './action-types';

export default function layout(state = getDefaultState(), action) {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case types.LAYOUT_SETTING:
      _.set(newState, action.path, action.value);
      break;
    case types.RECEIVE_SCREENCONNECT_PASSWORD:
      newState.sso.screenConnectPassword = action.screenConnectPassword;
      break;
    case types.RECEIVE_ZABBIX_PASSWORD:
      newState.sso.zabbixPassword = action.zabbixPassword;
      break;
    default:
      return state;
  }

  return newState;
}


function getDefaultState() {
  const state = { sso: {}, rightPane: { position: 0, collapsed: false, activeTab: 'triage' }, menu: { position: 0 } };
  const hash = window.location.hash;

  if (isMobile) {
    state.menu.position = menuWidth * -1;
    state.rightPane = { position: rightPaneWidth, collapsed: false, activeTab: 'triage' };

    if (hash === '#triage') state.rightPane.position = 0;
  }

  return state;
}
